import { Button } from '@/components/ui/button'
import { TableCell, TableRow } from '@/components/ui/table'
import type { IncomeAmounts } from '@/pages/IncomeReportPage'
import { displayShortDate } from '@/lib/dates'

export interface IncomeReportInvoice extends Omit<IncomeAmounts, 'invoice_count'> {
  id: number | string
  invoice_id: number
  number: number
  contact_name: string
  origin: string
  issued_on: string
  occurred_on: string
  kind: 'issued' | 'reversal'
}

export function IncomeReportInvoiceRow({
  invoice,
  onOpenInvoice,
}: {
  invoice: IncomeReportInvoice
  onOpenInvoice: (invoiceId: number) => void
}) {
  const reversal = invoice.kind === 'reversal'
  return (
    <TableRow
      className={reversal ? 'bg-destructive/5 text-destructive hover:bg-destructive/10' : undefined}
    >
      <TableCell className="pl-8">
        <div className="text-body-sm">
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-auto border-0 bg-transparent p-0 font-medium hover:bg-transparent"
            onClick={() => onOpenInvoice(invoice.invoice_id)}
          >
            INV-{invoice.number}
          </Button>{' '}
          · {invoice.contact_name} · {reversal ? 'Void reversal' : invoice.origin}
        </div>
        <div
          className={
            reversal ? 'text-caption text-destructive/80' : 'text-caption text-muted-foreground'
          }
        >
          {reversal ? 'Voided' : 'Issued'} {formatIssueDate(invoice.occurred_on)}
        </div>
      </TableCell>
      {[
        invoice.gross,
        zeroAsDash(invoice.discount_cents, invoice.discount),
        zeroAsDash(invoice.tax_cents, invoice.tax),
        invoice.net,
      ].map((amount, index) => (
        <TableCell key={`${invoice.id}-${index}`} className="text-right tabular-nums">
          {amount}
        </TableCell>
      ))}
    </TableRow>
  )
}

function zeroAsDash(cents: number, amount: string) {
  return cents === 0 ? '—' : amount
}

const formatIssueDate = displayShortDate
